import { AUTH_ROUTE_ID } from '@/integrations/tanstack-router/auth-route-id';

export const DELIVERY_ROOM_ROUTES = {
  index: '/delivery-room',
  patientList: '/delivery-room/patients',
  maternityProfile: '/delivery-room/patients/$id',
  assessmentForms: '/delivery-room/patients/$id/assessment-forms',
} as const;

export const DELIVERY_ROOM_ROUTE_IDS = {
  patientList: `/${AUTH_ROUTE_ID}${DELIVERY_ROOM_ROUTES.patientList}`,
  maternityProfile: `/${AUTH_ROUTE_ID}${DELIVERY_ROOM_ROUTES.maternityProfile}`,
  assessmentForms: `/${AUTH_ROUTE_ID}${DELIVERY_ROOM_ROUTES.assessmentForms}`,
} as const;
